import { Component, OnInit, Input } from '@angular/core';
import { Concept } from 'src/model/Concept/Concept';
import { ConceptLink } from 'src/model/Concept/ConceptLink';
import { ConceptTypeLink } from 'src/model/Concept/ConceptTypeLink';

@Component({
  selector: 'app-research-index-entry',
  templateUrl: './research-index-entry.component.html',
  styleUrls: ['./research-index-entry.component.css']
})
export class ResearchIndexEntryComponent implements OnInit {
  @Input() concept: Concept;
  opened: boolean = false;


  constructor() { }

  ngOnInit() {
  }

  public getIconClass()
  {
    if (this.opened)
      return "fa fa-minus-square margin-right-5";
    return "fa fa-plus-square margin-right-5";
  }

  public getDivStyle()
  {
    if (this.opened)
      return "inline-block";
    return "none";
  }

  public showUrls()
  {
    this.opened = !this.opened;
  }

  public getConceptType(conceptLink: ConceptLink)
  {
      let conceptType: string = ConceptTypeLink[conceptLink.conceptLinkType];
      return conceptType;
  }

  public isBlog(conceptLink: ConceptLink)
  {
      if (conceptLink.conceptLinkType == ConceptTypeLink.Blog || conceptLink.conceptLinkType == 2)
          return true;
      return false;
  }

  public isVideoCourse(conceptLink: ConceptLink)
  {
      if (conceptLink.conceptLinkType == ConceptTypeLink.VideoCourse || conceptLink.conceptLinkType == 0)
          return true;
      return false;
  }

  public isShortVideo(conceptLink: ConceptLink)
  {
      if (conceptLink.conceptLinkType == ConceptTypeLink.ShortVideos || conceptLink.conceptLinkType == 3)
          return true;
      return false;
  }

  public isFoundationOfLaw(conceptLink: ConceptLink)
  {
      if (conceptLink.conceptLinkType == ConceptTypeLink.FoundationsOfLaw || conceptLink.conceptLinkType == 1)
          return true;
      return false;
  }

  public isAlias(conceptLink: ConceptLink)
  {
      if (conceptLink.conceptLinkType == ConceptTypeLink.FoundationsOfLaw || conceptLink.conceptLinkType == 4)
          return true;
      return false;
  }

  public GetHumanReadableTimeIndex(conceptLink: ConceptLink)
  {
      if (conceptLink.TimeIndex < 1)
          return "";
      return Math.floor(conceptLink.TimeIndex / 60) + ":" + (conceptLink.TimeIndex % 60);
  }



}
